import React from 'react';

export default function Brand({brand}) {
    if (!brand?.logo) {
        return null;
    }

    const {name, logo} = brand;

    return (
        <div className="product-information__brand">
            <img className="product-information__brand-logo" src={logo?.svgPath} alt={name}/>
        </div>
    );
}
